import styled, { css } from 'styled-components'

import {
    FlexAlignItemsCenter,
    FlexCentered,
    AbsolutePositioning,
} from 'components/common/genericStyles'

const childDivAbsolute = css`
    & > div {
        position: absolute;
        top: 0;
        right: 0;
    }
`

export const Wrappers = {
    Student: styled.div`
        position: relative;
        height: 0;

        ${childDivAbsolute}
    `,
    Teacher: styled.div`
        position: relative;
        height: 90%;
        width: 90%;

        ${props => {
            const { hasTeacherJoined, studentsCount } = props

            const tilSize =
                studentsCount > 2 &&
                css`
                    height: 0;
                    width: 90%;
                    padding-top: 90%;
                `

            return css`
                ${tilSize}
                ${hasTeacherJoined && childDivAbsolute}
            `
        }}
    `,
}

export const Sections = {
    Teacher: styled.div`
        height: 100%;
        ${FlexCentered}
        transition: all 0.2s ease;
        order: 1;
    `,
    Student: styled.div`
        width: 30%;
        height: 100%;
        order: 2;

        ${FlexAlignItemsCenter}
        flex-direction: column;
        justify-content: space-evenly;

        ${props => {
            const { left, right, children } = props
            let placement = 'unset'
            if (children.length > 2) {
                placement = left ? 'flex-start' : placement
                placement = right ? 'flex-end' : placement
            }

            let size = 100
            size = children.length === 2 ? 65 : size
            size = children.length === 3 ? 48.5 : size

            const scale = (left || right) && children.length >= 2 ? 1.13 : 1

            let padding = left ? 'padding-left' : right ? 'padding-right' : ''
            padding = padding ? `${padding}: 50px;` : ''

            return css`
                div:nth-child(1) {
                    align-self: ${placement};
                }
                div:nth-child(3) {
                    align-self: ${placement};
                }

                ${padding}

                ${Wrappers.Student} {
                    width: ${size}%;
                    padding-top: ${size}%;
                    transform: scale(${scale});
                }

                ${left && 'order: 0;'}
            `
        }}
    `,
}

export const Container = styled.div`
    ${FlexAlignItemsCenter}

    width: 100%;
    height: 100%;
    padding: 10px;

    ${props => {
        const { isTeacherFullScreen, studentsCount } = props
        let teacherSectionWidth = studentsCount > 2 ? 40 : 70
        teacherSectionWidth = isTeacherFullScreen ? 100 : teacherSectionWidth

        const studentsSectionDisp = isTeacherFullScreen ? 'none' : 'flex'

        const fullScreenTeacherStyles = isTeacherFullScreen
            ? css`
                  ${AbsolutePositioning}
                  height: 100vh;
                  width: 100vw;
                  background: #222222;
                  z-index: 999;

                  ${Wrappers.Teacher} {
                      width: 98%;
                      height: 98%;
                      padding-top: 0;
                  }
              `
            : null

        return css`
            ${Sections.Teacher} {
                width: ${teacherSectionWidth}%;
                ${fullScreenTeacherStyles}
            }
            ${Sections.Student} {
                display: ${studentsSectionDisp};
            }
        `
    }}
`

export const Pagination = {
    Area: styled.div`
        ${FlexAlignItemsCenter}
        justify-content: space-evenly;
        padding: 10px;
        width: 100px;
        height: 40px;
        background: #36383c;
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
            0px 4px 12px -4px rgba(0, 0, 0, 0.08);
        border-radius: 44px;
    `,
    Button: styled.img`
        ${({ disabled }) => {
            const opacity = disabled ? 0.5 : 1
            const cursor = disabled ? 'not-allowed' : 'pointer'

            return `cursor: ${cursor}; opacity:${opacity};`
        }}
    `,
}
